module.exports = __webpack_public_path__ + "img/grupo-sid-2.bddc3d46.png";